import { render, staticRenderFns } from "./StatusPush.vue?vue&type=template&id=72b25b18&"
import script from "./StatusPush.vue?vue&type=script&lang=js&"
export * from "./StatusPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports